import React from "react";
import LargeNumber from "$components/info-list/content/large-number";
import SimpleLineChart from "$components/charts/simple-line";

import { abbrNum } from "$utils/number-helper";

const RevenueCell = ({ value, history }) => {
    const isHealthy = true;
    return (
        <div className="chart-column-container">
            <SimpleLineChart data={history} width="94px" height="62px" xKey="revenue" yKey="revenue" isHealthy={isHealthy} hasFill={true} />
            <LargeNumber value={`$${abbrNum(value)}`} isHealthy={isHealthy} />
        </div>
    );
};

export default RevenueCell;
